import React from "react";
import { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { classes } from "../Data/Layouts";
import SetPassword from "../Components/SetPassword/SetPassword";
import MeetingList from "../Components/Application/Admin/MeetingPage/MeetingList";
import MeetingPage from "../Components/Application/Admin/MeetingPage/MeetingPage";

const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [authenticated, setAuthenticated] = useState(false);
  const defaultLayoutObj = classes.find(
    (item) => Object.values(item).pop(1) === "compact-wrapper",
  );
  const layout =
    localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

  useEffect(() => {
    let abortController = new AbortController();
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  // Get user role for routing decisions
  const user = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = user?.role === "admin" || user?.role === "superadmin";

  return (
    <BrowserRouter basename={"/"}>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={"/"} element={<PrivateRoute />}>
            {login || authenticated ? (
              <>
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}`}
                  element={
                    isAdmin ? (
                      <Navigate
                        to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
                      />
                    ) : (
                      <Navigate
                        to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
                      />
                    )
                  }
                />
                <Route
                  exact
                  path={`/`}
                  element={
                    isAdmin ? (
                      <Navigate
                        to={`${process.env.PUBLIC_URL}/dashboard/${layout}`}
                      />
                    ) : (
                      <Navigate
                        to={`${process.env.PUBLIC_URL}/mursal-meetings`}
                      />
                    )
                  }
                />
              </>
            ) : (
              ""
            )}
            <Route path={`/*`} element={<LayoutRoutes />} />
          </Route>

          {/* Login routes */}
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/login`}
            element={<Signin />}
          />
          {/* Login with meeting ID */}
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/login/:meetingId`}
            element={<Signin />}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/set-password`}
            element={<SetPassword />}
          />

          {/* Meeting routes */}
          <Route
            path={`${process.env.PUBLIC_URL}/mursal-meetings`}
            element={<MeetingList />}
          />
          <Route
            path={`${process.env.PUBLIC_URL}/mursal-meetings/:meetingId`}
            element={<MeetingPage />}
          />

          {authRoutes.map(({ path, Component }, i) => (
            <Route path={path} element={Component} key={i} />
          ))}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
